// client/src/utils/languages.js
const languages = [
    { value: 'abkhazian', label: 'Abkhazian' },
    { value: 'afar', label: 'Afar' },
    { value: 'afrikaans', label: 'Afrikaans' },
    { value: 'akan', label: 'Akan' },
    { value: 'albanian', label: 'Albanian' },
    { value: 'amharic', label: 'Amharic' },
    { value: 'arabic', label: 'Arabic' },
    { value: 'aragonese', label: 'Aragonese' },
    { value: 'armenian', label: 'Armenian' },
    { value: 'assamese', label: 'Assamese' },
    { value: 'avaric', label: 'Avaric' },
    { value: 'avestan', label: 'Avestan' },
    { value: 'aymara', label: 'Aymara' },
    { value: 'azerbaijani', label: 'Azerbaijani' },
    { value: 'bambara', label: 'Bambara' },
    { value: 'bashkir', label: 'Bashkir' },
    { value: 'basque', label: 'Basque' },
    { value: 'belarusian', label: 'Belarusian' },
    { value: 'bengali', label: 'Bengali' },
    { value: 'bihari', label: 'Bihari' },
    { value: 'bislama', label: 'Bislama' },
    { value: 'bosnian', label: 'Bosnian' },
    { value: 'breton', label: 'Breton' },
    { value: 'bulgarian', label: 'Bulgarian' },
    { value: 'burmese', label: 'Burmese' },
    { value: 'catalan', label: 'Catalan' },
    { value: 'chamorro', label: 'Chamorro' },
    { value: 'chechen', label: 'Chechen' },
    { value: 'chichewa', label: 'Chichewa' },
    { value: 'chinese', label: 'Chinese' },
    { value: 'chuvash', label: 'Chuvash' },
    { value: 'cornish', label: 'Cornish' },
    { value: 'corsican', label: 'Corsican' },
    { value: 'cree', label: 'Cree' },
    { value: 'croatian', label: 'Croatian' },
    { value: 'czech', label: 'Czech' },
    { value: 'danish', label: 'Danish' },
    { value: 'divehi', label: 'Divehi' },
    { value: 'dutch', label: 'Dutch' },
    { value: 'dzongkha', label: 'Dzongkha' },
    { value: 'english', label: 'English' },
    { value: 'esperanto', label: 'Esperanto' },
    { value: 'estonian', label: 'Estonian' },
    { value: 'ewe', label: 'Ewe' },
    { value: 'faroese', label: 'Faroese' },
    { value: 'fijian', label: 'Fijian' },
    { value: 'finnish', label: 'Finnish' },
    { value: 'french', label: 'French' },
    { value: 'fulah', label: 'Fulah' },
    { value: 'galician', label: 'Galician' },
    { value: 'georgian', label: 'Georgian' },
    { value: 'german', label: 'German' },
    { value: 'greek', label: 'Greek' },
    { value: 'guarani', label: 'Guarani' },
    { value: 'gujarati', label: 'Gujarati' },
    { value: 'haitian creole', label: 'Haitian Creole' },
    { value: 'hausa', label: 'Hausa' },
    { value: 'hebrew', label: 'Hebrew' },
    { value: 'herero', label: 'Herero' },
    { value: 'hindi', label: 'Hindi' },
    { value: 'hiri motu', label: 'Hiri Motu' },
    { value: 'hungarian', label: 'Hungarian' },
    { value: 'icelandic', label: 'Icelandic' },
    { value: 'ido', label: 'Ido' },
    { value: 'igbo', label: 'Igbo' },
    { value: 'indonesian', label: 'Indonesian' },
    { value: 'interlingua', label: 'Interlingua' },
    { value: 'interlingue', label: 'Interlingue' },
    { value: 'inuktitut', label: 'Inuktitut' },
    { value: 'inupiaq', label: 'Inupiaq' },
    { value: 'irish', label: 'Irish' },
    { value: 'italian', label: 'Italian' },
    { value: 'japanese', label: 'Japanese' },
    { value: 'javanese', label: 'Javanese' },
    { value: 'kalaallisut', label: 'Kalaallisut' },
    { value: 'kannada', label: 'Kannada' },
    { value: 'kanuri', label: 'Kanuri' },
    { value: 'kashmiri', label: 'Kashmiri' },
    { value: 'kazakh', label: 'Kazakh' },
    { value: 'khmer', label: 'Khmer' },
    { value: 'kikuyu', label: 'Kikuyu' },
    { value: 'kinyarwanda', label: 'Kinyarwanda' },
    { value: 'kirghiz', label: 'Kirghiz' },
    { value: 'komi', label: 'Komi' },
    { value: 'kongo', label: 'Kongo' },
    { value: 'korean', label: 'Korean' },
    { value: 'kurdish', label: 'Kurdish' },
    { value: 'kwanyama', label: 'Kwanyama' },
    { value: 'lao', label: 'Lao' },
    { value: 'latin', label: 'Latin' },
    { value: 'latvian', label: 'Latvian' },
    { value: 'limburgan', label: 'Limburgan' },
    { value: 'lingala', label: 'Lingala' },
    { value: 'lithuanian', label: 'Lithuanian' },
    { value: 'luba-katanga', label: 'Luba-Katanga' },
    { value: 'luxembourgish', label: 'Luxembourgish' },
    { value: 'macedonian', label: 'Macedonian' },
    { value: 'malagasy', label: 'Malagasy' },
    { value: 'malay', label: 'Malay' },
    { value: 'malayalam', label: 'Malayalam' },
    { value: 'maltese', label: 'Maltese' },
    { value: 'manx', label: 'Manx' },
    { value: 'maori', label: 'Maori' },
    { value: 'marathi', label: 'Marathi' },
    { value: 'marshallese', label: 'Marshallese' },
    { value: 'mongolian', label: 'Mongolian' },
    { value: 'nauru', label: 'Nauru' },
    { value: 'navajo', label: 'Navajo' },
    { value: 'ndonga', label: 'Ndonga' },
    { value: 'nepali', label: 'Nepali' },
    { value: 'north ndebele', label: 'North Ndebele' },
    { value: 'northern sami', label: 'Northern Sami' },
    { value: 'norwegian', label: 'Norwegian' },
    { value: 'norwegian bokmål', label: 'Norwegian Bokmål' },
    { value: 'norwegian nynorsk', label: 'Norwegian Nynorsk' },
    { value: 'occitan', label: 'Occitan' },
    { value: 'ojibwa', label: 'Ojibwa' },
    { value: 'oriya', label: 'Oriya' },
    { value: 'oromo', label: 'Oromo' },
    { value: 'ossetian', label: 'Ossetian' },
    { value: 'pali', label: 'Pali' },
    { value: 'pashto', label: 'Pashto' },
    { value: 'persian', label: 'Persian' },
    { value: 'polish', label: 'Polish' },
    { value: 'portuguese', label: 'Portuguese' },
    { value: 'punjabi', label: 'Punjabi' },
    { value: 'quechua', label: 'Quechua' },
    { value: 'romanian', label: 'Romanian' },
    { value: 'romansh', label: 'Romansh' },
    { value: 'rundi', label: 'Rundi' },
    { value: 'russian', label: 'Russian' },
    { value: 'samoan', label: 'Samoan' },
    { value: 'sango', label: 'Sango' },
    { value: 'sanskrit', label: 'Sanskrit' },
    { value: 'sardinian', label: 'Sardinian' },
    { value: 'scottish gaelic', label: 'Scottish Gaelic' },
    { value: 'serbian', label: 'Serbian' },
    { value: 'shona', label: 'Shona' },
    { value: 'sichuan yi', label: 'Sichuan Yi' },
    { value: 'sindhi', label: 'Sindhi' },
    { value: 'sinhala', label: 'Sinhala' },
    { value: 'slovak', label: 'Slovak' },
    { value: 'slovenian', label: 'Slovenian' },
    { value: 'somali', label: 'Somali' },
    { value: 'south ndebele', label: 'South Ndebele' },
    { value: 'southern sotho', label: 'Southern Sotho' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'sundanese', label: 'Sundanese' },
    { value: 'swahili', label: 'Swahili' },
    { value: 'swati', label: 'Swati' },
    { value: 'swedish', label: 'Swedish' },
    { value: 'tagalog', label: 'Tagalog' },
    { value: 'tahitian', label: 'Tahitian' },
    { value: 'tajik', label: 'Tajik' },
    { value: 'tamil', label: 'Tamil' },
    { value: 'tatar', label: 'Tatar' },
    { value: 'telugu', label: 'Telugu' },
    { value: 'thai', label: 'Thai' },
    { value: 'tibetan', label: 'Tibetan' },
    { value: 'tigrinya', label: 'Tigrinya' },
    { value: 'tonga', label: 'Tonga' },
    { value: 'tsonga', label: 'Tsonga' },
    { value: 'tswana', label: 'Tswana' },
    { value: 'turkish', label: 'Turkish' },
    { value: 'turkmen', label: 'Turkmen' },
    { value: 'twi', label: 'Twi' },
    { value: 'uighur', label: 'Uighur' },
    { value: 'ukrainian', label: 'Ukrainian' },
    { value: 'urdu', label: 'Urdu' },
    { value: 'uzbek', label: 'Uzbek' },
    { value: 'venda', label: 'Venda' },
    { value: 'vietnamese', label: 'Vietnamese' },
    { value: 'volapük', label: 'Volapük' },
    { value: 'walloon', label: 'Walloon' },
    { value: 'welsh', label: 'Welsh' },
    { value: 'western frisian', label: 'Western Frisian' },
    { value: 'wolof', label: 'Wolof' },
    { value: 'xhosa', label: 'Xhosa' },
    { value: 'yiddish', label: 'Yiddish' },
    { value: 'yoruba', label: 'Yoruba' },
    { value: 'zhuang', label: 'Zhuang' },
    { value: 'zulu', label: 'Zulu' }
];

export default languages;